<template>
  <div class="container-fluid">
    <div class="login-background"></div>
    <Loader :show="isLoading"></Loader>
    <div class="row loginscreen justify-content-center">
      <div class="col-lg-6 col-xl-3 col-12 col-md-9">
        <div class="row">
          <div class="col-lg-12 col-md-12  justify-content-center">
            <div class="display-flex">
              <div class="login-logo">
                <img src="img/iceberg-logo.svg" alt>
              </div>
              <div v-if="!maintenance">
                <div class="user-login">
                  <span class="user-login-text">USER LOGIN</span>
                </div>
              </div>
              <div class="d-flex flex-column" v-else>
                <div class="user-login">
                  <span class="user-login-text">
                    MAINTENANCE
                  </span>
                </div>
                <span class="s-20 mb-3">
                  Our server is under maintenance and due to be back online by <span class="bold"> Sunday at 5pm </span>
                </span>
              </div>
              <div v-if="!maintenance">
                <div class="login-form">
                  <div class="col-12 px-0">
                    <div class="form-group">
                      <div class="ls-input--black">
                        <label>Email Address</label>
                        <i class="fal fa-user icon fa-lg"></i>
                        <input type="email" class="login-input" autocomplete="on" name="E-mail" autocapitalize="off" v-model="auth.email" @keyup.enter="login()" required>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 px-0">
                    <div class="form-group">
                      <div class="ls-input--black">
                        <label>Password</label>
                        <div @click="togglePassword">
                          <template v-if="showPassword">
                            <div>
                              <i class="far fa-eye-slash icon fa-lg mouse-click"></i>
                            </div>
                          </template>
                          <template v-else>
                            <div>
                              <i class="far fa-eye icon fa-lg mouse-click"></i>
                            </div>
                          </template>
                        </div>
                        <input
                          :type="showPassword ? 'text' : 'password'"
                          class="login-input"
                          name="Password"
                          v-model="auth.password"
                          @keyup.enter="login()"
                          required
                        >
                      </div>
                    </div>
                  </div>
                  <div class="custom-checkbox mb-3">
                    <div class="row no-gutters">
                      <div class="col-6 d-flex justify-content-start">
                        <input type="checkbox" style="color: #ffffff" class="custom-control-input checkbox" id="rememberMe" v-model="rememberStatus">
                        <label class="custom-control-label ml-4 mouse-click" for="rememberMe">Remember Me</label>
                      </div>
                      <div class="col-6 d-flex justify-content-end">
                        <router-link to="/auth/forgot">
                          <span  style="color: #ffffff" class="trouble">Having trouble logging in</span>
                        </router-link>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <button
                      type="submit"
                      class="btn ls-btn-primary w-100 mb-1"
                      @click="login"
                    >LOGIN</button>
                  </div>
                </div>
                <result-box :type="false" :data="authError" v-if="authError" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';

import Loader from '@/components/Loader.vue';
import ResultBox from '@/modules/common/components/result/ResultBox.vue';
import AuthService from '@/modules/users/services/authService';

export default {
  name: 'TheLogin',
  components: { Loader, ResultBox },
  data() {
    return {
      auth: {
        email: null,
        password: null,
      },
      showPassword: false,
      maintenance: false,
      rememberStatus: false,
      isLoading: false,
    };
  },
  computed: {
    ...mapState('Auth', ['authError']),
    ...mapState('Users', ['isLogged']),
    ...mapGetters('Users', ['isProduction']),
  },
  methods: {
    ...mapActions('Auth', ['resetTokenError']),
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    async login() {
      if (this.isProduction) {
        this.auth.email = this.auth.email.toLowerCase();
        this.isLoading = true;
        const authStatus = await new AuthService().login(this.auth);
        if (authStatus) {
          this.isLoading = false;
        }
        if (this.rememberStatus === true) {
          this.$store.dispatch('Auth/fetchRemember', this.rememberStatus);
        } else {
          this.$store.dispatch('Auth/fetchNotRemember', this.rememberStatus);
        }
      } else {
        this.auth.email = this.auth.email.toLowerCase();
        this.isLoading = true;
        const authStatus = await new AuthService().login(this.auth);
        if (authStatus && authStatus[0]) {
          this.isLoading = false;
          // eslint-disable-next-line prefer-destructuring
          this.$store.state.Auth.authError = authStatus[0];
        } else {
          this.isLoading = false;
        }
        if (this.rememberStatus === true) {
          this.$store.dispatch('Auth/fetchRemember', this.rememberStatus);
        } else {
          this.$store.dispatch('Auth/fetchNotRemember', this.rememberStatus);
        }
      }
    },
  },
  created() {
    if (localStorage.getItem(process.env.VUE_APP_TOKEN_NAME)) {
      this.$store.dispatch('Users/fetchMe');
    }
    this.resetTokenError();
  },
};
</script>

<style scoped>
  .login-background {
    position: fixed;
    background-color: #232b2b;
    width: 100%;
    height: 100%;
    z-index: 0;
    top: 0px;
    left: 0px;
  }
.custom-control-label:before{
  border-color: white !important;
  border-radius: 0px !important
}
</style>
